import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppearanceProvider, useAppearance } from './context/AppearanceContext';

// === OLYMP PAGES ===
import OlympDashboard from './pages/olymp/OlympDashboard';
import DataCatalog from './pages/olymp/DataCatalog';
import ParameterDetail from './pages/olymp/ParameterDetail';
import Cart from './pages/olymp/Cart';
import CohortGraphBuilder from './pages/olymp/cohorts/CohortGraphBuilder';
import Requests from './pages/olymp/Requests';
import MappingJobMonitorPage from './pages/olymp/MappingJobMonitorPage';

// Shared/Common Pages
import SettingsPage from './pages/SettingsPage';
import HelpSupportPage from './pages/HelpSupportPage';
import LoginPage from './auth/LoginPage';
import { AuthProvider } from './auth/authContext';
import ProtectedRoute from './auth/ProtectedRoute';

// Redirects '/' to the user's saved default homepage
const HomeRedirect = () => {
  const { getHomepagePath } = useAppearance();
  const path = getHomepagePath();
  if (path === '/') return <OlympDashboard />;
  return <Navigate to={path} replace />;
};

function App() {
  return (
    <AuthProvider>
      <AppearanceProvider>
      <Router>
        <Routes>
          {/* Öffentliche Route für Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* ===== OLYMP ROUTES ===== */}
          <Route path="/" element={
            <ProtectedRoute>
              <HomeRedirect />
            </ProtectedRoute>
          } />
          <Route path="/catalog" element={
            <ProtectedRoute>
              <DataCatalog />
            </ProtectedRoute>
          } />
          <Route path="/parameter/:parameterId" element={
            <ProtectedRoute>
              <ParameterDetail />
            </ProtectedRoute>
          } />
          <Route path="/cart" element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          } />
          <Route path="/cohorts" element={<Navigate to="/olymp/cohort-builder" replace />} />
          <Route path="/olymp/cohort-builder" element={
            <ProtectedRoute>
              <CohortGraphBuilder />
            </ProtectedRoute>
          } />
          <Route path="/olymp/cohort-graph" element={
            <ProtectedRoute>
              <Navigate to="/olymp/cohort-builder" replace />
            </ProtectedRoute>
          } />
          <Route path="/requests" element={
            <ProtectedRoute>
              <Requests />
            </ProtectedRoute>
          } />
          <Route path="/olymp/mapping-jobs/:jobId" element={
            <ProtectedRoute>
              <MappingJobMonitorPage />
            </ProtectedRoute>
          } />

          {/* Common Routes */}
          <Route path="/settings" element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute>
              <HelpSupportPage />
            </ProtectedRoute>
          } />

          {/* Standardroute zum Login umleiten */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
      </AppearanceProvider>
    </AuthProvider>
  );
}

export default App;
